import { Controller } from "@hotwired/stimulus";
import { getCanAndShouldUseScanner } from "../utils";

export default class extends Controller {
  /***
   * # Show Scan Link Controller
   *
   *
   *  ## Required API
   *  __Classes__
   *    * hide - applied and removed on hide
   *
   *  ## Optional API
   *  __Classes__
   *    * show - applied and removed on show
   *
   *  __Values__
   *  (will be evaluated if one is not set)
   *    * canUseScanner
   *    * shouldUseScanner
   */
  static values = {
    canUseScanner: Boolean,
    shouldUseScanner: Boolean,
  };
  static classes = ["show", "hide"];

  async connect() {
    await this.setScannerValues();
    this.setLinkTarget();
  }

  async setScannerValues() {
    if (!this.hasCanUseScannerValue || !this.hasShouldUseScannerValue) {
      try {
        const { canUseScanner, shouldUseScaner } =
          await getCanAndShouldUseScanner();
        this.canUseScannerValue = canUseScanner;
        this.shouldUseScannerValue = shouldUseScaner;
      } catch (e) {
        console.error(e);
        this.canUseScannerValue = false;
        this.shouldUseScannerValue = false;
      }
    }
  }

  setLinkTarget() {
    const linkElement = this.element;
    this._updateVisibility(linkElement);
  }

  _updateVisibility(linkElement) {
    if (this.canUseScannerValue) {
      linkElement.classList.add(...this.showClasses);
      linkElement.classList.remove(this.hideClass);
    } else {
      linkElement.classList.remove(...this.showClasses);
      linkElement.classList.add(this.hideClass);
    }
  }
}
